module.exports = __webpack_public_path__ + "img/Lime-24-Blog-Banner2.27371704.jpg";